// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".krTj[data-v-95f73390]{width:100%}.L1-m[data-v-95f73390]{margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "krTj",
	"comp__icon": "L1-m"
};
module.exports = ___CSS_LOADER_EXPORT___;
